import { render, staticRenderFns } from "./DetailVisitPointShipments.vue?vue&type=template&id=700e1e9c"
import script from "./DetailVisitPointShipments.vue?vue&type=script&lang=js"
export * from "./DetailVisitPointShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports